import { clone } from "lodash";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { MachineConfiguration } from "../../../shared/models/machineConfiguration";
import { CloneAndConversionService } from "../../../shared/services/cloneAndConversionService";
import { MachineSycuan } from "../../models/machine";
import { MachineConfigurationSycuan } from "../../models/machineConfiguration";
import { IQService } from "angular";

export const vsServiceName = "cloneAndConversionService";

export class CloneAndConversionServiceSycuan extends CloneAndConversionService<
  MachineSycuan,
  MachineConfigurationSycuan
> {
  static $inject = [ServerUtilityName, "$q"];
  constructor(serverUtility: ServerUtility, $q: IQService) {
    super(serverUtility, $q);
  }

  protected override prepareCloneConfiguration(
    cloneConfiguration: MachineConfigurationSycuan
  ): MachineConfigurationSycuan {
    cloneConfiguration = super.prepareCloneConfiguration(cloneConfiguration);
    cloneConfiguration.Section = undefined;
    cloneConfiguration.Bank = undefined;
    cloneConfiguration.Slot = undefined;
    cloneConfiguration.WarehouseLocation = undefined;
    cloneConfiguration.Date = undefined;
    cloneConfiguration.OnFloorDate = undefined;

    return cloneConfiguration;
  }

  protected override prepareConversionConfiguration(
    conversionConfiguration: MachineConfigurationSycuan,
    currentConfiguration: MachineConfigurationSycuan
  ): MachineConfigurationSycuan {
    const config = super.prepareConversionConfiguration(
      conversionConfiguration,
      currentConfiguration
    );
    return {
      ...config,
      Section: currentConfiguration.Section,
      Bank: currentConfiguration.Bank,
      Slot: currentConfiguration.Slot,
      Status: currentConfiguration.Status,
      OnFloorDate: currentConfiguration.OnFloorDate,
      WarehouseLocation: currentConfiguration.WarehouseLocation,
    };
  }
}
